import { clearAuth, getAuth, setAuth } from "../lib/authHelpers";
import { useRouter } from "@tanstack/react-router";

export function useAuth() {
  const router = useRouter();

  const auth = getAuth();

  const login = (data: any) => {
    setAuth(data);
  };

  const logout = () => {
    clearAuth();

    router.navigate({ to: "/", replace: true });
  };

  return {
    user: auth?.user ?? null,
    token: auth?.token ?? null,
    isLoggedIn: !!auth?.token,
    login,
    logout,
  };
}
